import pkg from '../package.json';
const nectaryDefinitions = new Map();
let nectaryRegistry = null;
export const defineCustomElement = (name, constructor) => {
  if (nectaryRegistry !== null) {
    if (nectaryRegistry.get(name) == null) {
      nectaryRegistry.define(name, constructor);
    }
    return;
  }
  nectaryDefinitions.set(name, constructor);
};
export const setNectaryRegistry = registry => {
  if (nectaryRegistry !== null) {
    throw new Error('Nectary registry already set');
  }
  nectaryRegistry = registry;
  for (const [name, ctor] of nectaryDefinitions.entries()) {
    if (nectaryRegistry.get(name) == null) {
      nectaryRegistry.define(name, ctor);
    }
  }
  nectaryDefinitions.clear();
};
export class NectaryElement extends HTMLElement {
  attachShadow(options) {
    return super.attachShadow({
      mode: 'open',
      delegatesFocus: false,
      customElements: nectaryRegistry,
      ...options
    });
  }
  version = pkg.version;
  get focusable() {
    return false;
  }
  #isDomConnected = false;
  connectedCallback() {
    this.#isDomConnected = true;
  }
  disconnectedCallback() {
    this.#isDomConnected = false;
  }
  get isDomConnected() {
    return this.#isDomConnected;
  }
}